import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import {listBreadcrumbs, white, breadcrumbButton} from './breadcrumb-list.module.scss';

const BreadcrumbList = ({ breadcrumbs, isHidden = false, color = null }) => {
    return (
        <nav aria-label="Breadcrumbs">
            <ol
                className={ isHidden ? `sr-only` : `${listBreadcrumbs} ${color === 'white' ? white : ''}` }
                vocab="http://schema.org/"
                typeof="BreadcrumbList">
                { breadcrumbs.map((breadcrumb, index) => (
                    <li
                        property="itemListElement"
                        typeof="ListItem"
                        key={ breadcrumb.url }
                        aria-current={ breadcrumbs.length - 1 === index ? `page` : `false` }>
                        <Link
                            to={ breadcrumb.url }
                            className={ `${breadcrumbButton} btn-text-sm` }
                            property="item"
                            typeof="WebPage">
                            <span property="name">
                                {breadcrumb.name}
                            </span>
                        </Link>
                        <meta property="position" content={index + 1} />
                    </li>
                )) }
            </ol>
        </nav>
    )
}

BreadcrumbList.propTypes = {
    breadcrumbs: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
    })).isRequired,
    isHidden: PropTypes.bool,
    color: PropTypes.string,
}

export default BreadcrumbList;
